// UI Component utilities

export class UIComponents {
    static createSlider(label, min, max, value, step, onChange) {
        const group = document.createElement('div');
        group.className = 'control-group';
        
        const labelEl = document.createElement('label');
        labelEl.textContent = label;
        group.appendChild(labelEl);
        
        const slider = document.createElement('input');
        slider.type = 'range';
        slider.min = min;
        slider.max = max;
        slider.step = step || 0.01;
        slider.value = value;
        group.appendChild(slider);
        
        const valueDisplay = document.createElement('div');
        valueDisplay.className = 'value-display';
        valueDisplay.textContent = parseFloat(value).toFixed(2);
        group.appendChild(valueDisplay);
        
        slider.addEventListener('input', (e) => {
            const val = parseFloat(e.target.value);
            valueDisplay.textContent = val.toFixed(2);
            if (onChange) {
                onChange(val);
            }
        });
        
        return { container: group, slider, valueDisplay };
    }

    static createColorPicker(label, value, onChange) {
        const group = document.createElement('div');
        group.className = 'control-group';
        
        const labelEl = document.createElement('label');
        labelEl.textContent = label;
        group.appendChild(labelEl);
        
        const colorInput = document.createElement('input');
        colorInput.type = 'color';
        colorInput.value = typeof value === 'string' ? value : `#${value.toString(16).padStart(6, '0')}`;
        group.appendChild(colorInput);
        
        colorInput.addEventListener('input', (e) => {
            if (onChange) onChange(e.target.value);
        });
        
        return { container: group, colorInput };
    }

    static createButton(label, onClick, className = '') {
        const button = document.createElement('button');
        button.className = `button ${className}`;
        button.textContent = label;
        button.addEventListener('click', onClick);
        return button;
    }
}
